import { AddAdmissionChecklist } from "app/screens/residents/show/AddAdmissionChecklist";

export default function AddAdmissionChecklistPage() {
  return <AddAdmissionChecklist />;
}
